import { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import { Chip, Divider } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Link from '@mui/material/Link';
import { ScrollTypography } from '../../Styles';
import dayjs from 'dayjs';

import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import Stack from '@mui/material/Stack';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import DownloadIcon from '@mui/icons-material/Download';
import { OpenSwal } from '../../Utils';
// import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { saveAs } from 'file-saver';
import { LoadingButton } from '@mui/lab';
import { url_get_voucher_html } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';
// import { useSelector } from 'react-redux';
// import { InterpreteredDurationRedux } from '../../Redux/Interpreter/AssignmentStartEndIntDuration';
// sched-1436-stars
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
//sched-1436-ends



export default function AssignmentAfterGetStarted({ assign_id, AssignmentDetailsAry, AssignmentStartdateTime, AssignmentEndPageDetails, AssignmentEndPageDetailsSet, onTimeValidationChange, DialogBoxStatusSet, URLThirdSegmentName }) {

    const [DownloadVoucherLoadingButton, DownloadVoucherLoadingButtonSet] = useState(false);
    // const InterpreteredDurationReduxValue = useSelector(InterpreteredDurationRedux);
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const navigate = useNavigate();


    const AssignmentDownloadVoucherHtml = (assign_id) => {
        DownloadVoucherLoadingButtonSet(true);
        let payload_data = { assignid: assign_id }
        apiWithAuth.post(url_get_voucher_html, payload_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                DownloadVoucherLoadingButtonSet(false);
                saveAs(response.data.file_blob, response.data.file_name);
            } else if (response.data.status === false && response.data.message === "Token Expired") {
                DownloadVoucherLoadingButtonSet(false);
                OpenSwal('Token_error', navigate);
            } else {
                DownloadVoucherLoadingButtonSet(false);
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            DownloadVoucherLoadingButtonSet(false);
            OpenSwal('Axios_error', response.message);
        });
    }
    // console.log(InterpreteredDurationReduxValue);

    //Sched-1436-starts
    const [editStartTime, setEditStartTime] = useState(false);
    const [startTime, setStartTime] = useState(dayjs());
    const [startTimeError, setStartTimeError] = useState("");
    
    useEffect(() => {
        if (AssignmentStartdateTime?.applied_startime) {
            setStartTime(dayjs(AssignmentStartdateTime.applied_startime));
        }
    }, [AssignmentStartdateTime]);
    
    const [editEndTime, setEditEndTime] = useState(false);

    const [endTime, setEndTime] = useState(
        AssignmentEndPageDetails?.assign_endtime
            ? dayjs(AssignmentEndPageDetails.assign_endtime)
            : dayjs()
    );
    
    const [endTimeError, setEndTimeError] = useState("");

    useEffect(() => {
        onTimeValidationChange?.(Boolean(startTimeError || endTimeError));
    }, [startTimeError, endTimeError, onTimeValidationChange]);
    useEffect(() => {
        if (AssignmentEndPageDetails?.assign_endtime) {
            setEndTime(dayjs(AssignmentEndPageDetails.assign_endtime));
        }
    }, [AssignmentEndPageDetails]);

    const assignmentStartTime = dayjs(
        AssignmentStartdateTime.applied_startime
    );
    
    const minEndTime = assignmentStartTime;
    
    const maxEndTime = assignmentStartTime.add(24, "hour");


    const getInterpretedDuration = () => {
        if (!startTime || !endTime) {
        return AssignmentDetailsAry.assign_interpreted_duration;
        }
        
        
        const timezone = AssignmentDetailsAry.assign_client_timezone;
        
        const start = timezone
            ? dayjs(startTime).tz(timezone, true)
            : dayjs(startTime);
        
        const end = timezone
            ? dayjs(endTime).tz(timezone, true)
            : dayjs(endTime);
        
        if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
            return AssignmentDetailsAry.assign_interpreted_duration;
        }
        
        const totalMinutes = end.diff(start, "minute");
        
        const days = Math.floor(totalMinutes / 1440);
        const hours = Math.floor((totalMinutes % 1440) / 60);
        const minutes = totalMinutes % 60;
        
        let duration = "";
        
        if (days > 0) {
            duration += `${days} Day${days > 1 ? "s" : ""} `;
        }
        
        if (hours > 0) {
            duration += `${hours} Hour${hours > 1 ? "s" : ""} `;
        }
        
        duration += `${minutes} Minute${minutes !== 1 ? "s" : ""}`;
        
        return duration.trim();
     
        
        };
    const minStartTime = dayjs(AssignmentDetailsAry.assign_requestdatetime).subtract(
        15,
        "minute"
    );

    useEffect(() => {

        if (
            !startTime ||
            !endTime ||
            !AssignmentDetailsAry.assign_requestdatetime ||
            !AssignmentDetailsAry.assign_duration
        ) {
            return;
        }
    
        const assignmentStart = dayjs(startTime);
    
        const scheduledEndTime = dayjs(
            AssignmentDetailsAry.assign_requestdatetime
        ).add(
            parseInt(AssignmentDetailsAry.assign_duration),
            "minute"
        );
    
        const maxAllowedEnd = scheduledEndTime.add(24, "hours");
    
        const assignmentEnd = dayjs(endTime);
    
        if (assignmentEnd.isBefore(assignmentStart)) {
    
            setEndTimeError(
                `End Date & Time cannot be earlier than the Assignment Start Time (${assignmentStart.format(
                    "MM/DD/YYYY hh:mm A"
                )}).`
            );
    
            return;
        }
    
        if (assignmentEnd.isAfter(maxAllowedEnd)) {
    
            setEndTimeError(
                `End Date & Time cannot be more than 24 hours after the Scheduled End Date & Time.`
            );
    
            return;
        }
    
        setEndTimeError("");
    
    }, [
        startTime,
        endTime,
        AssignmentDetailsAry.assign_requestdatetime,
        AssignmentDetailsAry.assign_duration
    ]);

    //Sched-1436-ends

    return (
        <Box>
            <Box sx={{ mt: 2, ml: { xs: 0, sm: 1 } }}>
                <Stack direction="row" spacing={1}>
                    <Typography variant="h5" sx={{ padding:"20px 0px 0px 0px" }} fontWeight="bold" color={appThemeColor}>  {AssignmentDetailsAry.assign_industry} </Typography>
                    {/* {AssignmentDetailsAry.assign_applicant_counts === 1 && <Box  >{URLThirdSegmentName === "Assignment_Acceptence" && <Chip label={<Typography variant='caption' sx={{ whiteSpace: 'nowrap' }} >QR Code</Typography>} size="small" onClick={() => DialogBoxStatusSet(true)} sx={{ backgroundColor: '#89B601', color: '#fff', borderRadius: 2, height: '20px', width: '70px', cursor: 'pointer', '&:hover': { backgroundColor: '#6f9401' }, mb: -1 }} />}</Box>} */}
                </Stack>
                <Typography variant="h6" fontWeight="bold" color={appThemeColor} sx={{ mt: -0.8 }}  > {AssignmentDetailsAry.assign_client_name} </Typography>

                {AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Box sx={{ wordWrap: 'break-word', width: '100%', mt: -1 }} >
                    <Typography variant="subtitle2" color={appThemeColor} > {AssignmentDetailsAry.assign_location}</Typography>
                </Box>}




                <Box sx={{ mt: 1 }}>



                    {/* <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Time Reported</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentDetailsAry.assign_reporting_time).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid> */}
                    <Divider sx={{ borderRadius: '10px' }} />

                    <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Reported To</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}>
                        {AssignmentDetailsAry.assign_requester_details.new_requester_name === "" && <Box sx={ScrollTypography}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_requester_details.requester_name}</ Typography></Box>}
                        {AssignmentDetailsAry.assign_requester_details.new_requester_name !== "" && <Box sx={ScrollTypography}><Typography variant='body2' color='red' sx={{ textDecoration: 'line-through', mr: 0.5 }}>{AssignmentDetailsAry.assign_requester_details.requester_name}</Typography><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_requester_details.new_requester_name}</Typography></ Box>}
                    </Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    {(AssignmentDetailsAry.service_type === "Over the Phone") && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Dial Phone</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}><Link href={'tel:' + AssignmentDetailsAry.assign_add_row_by_service_type} underline="hover" variant="body2" color={appThemeColor}> {AssignmentDetailsAry.assign_add_row_by_service_type} </Link></ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /></Box>}
                    {(AssignmentDetailsAry.service_type === "Video Remote") && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Video Link</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor} ><Link variant='body2' target='_blank' underline="hover" href={AssignmentDetailsAry.assign_add_row_by_service_type} color={appThemeColor}>{AssignmentDetailsAry.assign_add_row_by_service_type}</Link></ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /></Box>}
                    {(AssignmentDetailsAry?.assign_consumer_service_name && AssignmentDetailsAry?.assign_consumer_service_name !== '') && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Consumer of Service</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_consumer_service_name}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /> </Box>}
                    {(AssignmentDetailsAry?.assign_instruction && AssignmentDetailsAry?.assign_instruction !== '') && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Special Instructions</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_instruction}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /> </Box>}
                    {(AssignmentDetailsAry.assign_post_status === 'Check Out') && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Assignment Start Time</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentDetailsAry.assign_start_time_value).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /></Box>}
                    {(AssignmentDetailsAry.assign_post_status === 'Lapsed' && AssignmentEndPageDetails.checkout_type !== "" && AssignmentEndPageDetails.assign_startime !== "") && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Assignment Start Time</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentEndPageDetails.assign_startime).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /> </Box>}
                    {/* {(AssignmentDetailsAry.assign_post_status === 'Check In' && AssignmentStartdateTime.applied_startime !== "") && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Assignment Start Time</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentStartdateTime.applied_startime).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /> </Box>} */}
                        {AssignmentDetailsAry.assign_post_status === "Check In" &&
AssignmentStartdateTime.applied_startime !== "" && (
    <Box>
        <Grid container alignItems="center">
            <Grid xs={12} sm={4} md={3}>
                <Typography variant="body2" fontWeight="bold">
                    Assignment Start Time
                </Typography>
            </Grid>

            <Grid xs={12} sm={8} md={9}>
                {!editStartTime ? (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2" color={appThemeColor}>
                            {dayjs(startTime).format("hh:mm A [on] MM/DD/YYYY")}
                        </Typography>

                        <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => setEditStartTime(true)}
                        >
                            <EditIcon
                                fontSize="small"
                                sx={{ color: appThemeColor }}
                            />
                        </IconButton>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                        }}
                    >
                       <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DateTimePicker
        value={startTime}
        views={["year", "month", "day", "hours", "minutes"]}
        ampm
        minDateTime={minStartTime}
        disableFuture
        onChange={(newValue) => {
            if (!newValue) return;

            if (dayjs(newValue).isBefore(minStartTime)) {
                setStartTimeError(
                    `Start time cannot be earlier than ${minStartTime.format(
                        "MM/DD/YYYY hh:mm A"
                    )}`
                );
                return;
            }

            setStartTime(dayjs(newValue));
            setStartTimeError("");
        }}
        slotProps={{
            textField: {
                size: "small",
                error: startTimeError !== "",
                helperText: startTimeError,
            },
        }}
    />
</LocalizationProvider>

<IconButton
    color="success"
    onClick={() => {
        const minStartTime = dayjs(
            AssignmentDetailsAry.assign_requestdatetime
        ).subtract(15, "minute");

        if (startTime.isBefore(minStartTime)) {
            setStartTimeError(
                `Start time cannot be earlier than ${minStartTime.format(
                    "MM/DD/YYYY hh:mm A"
                )}`
            );
            return;
        }

        AssignmentEndPageDetailsSet((previous) => ({
            ...previous,
            assign_startime: startTime.format("YYYY-MM-DD HH:mm:ss"),
        }));

        setEditStartTime(false);
    }}
>
    <CheckIcon />
</IconButton>

                        <IconButton
                            color="error"
                            onClick={() => {

                                setStartTime(
                                    dayjs(
                                        AssignmentStartdateTime.applied_startime
                                    )
                                );

                                setStartTimeError("");

                                setEditStartTime(false);
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                )}
            </Grid>
        </Grid>

        <Divider sx={{ borderRadius: "10px" }} />
    </Box>
)}

{/* {(AssignmentDetailsAry.assign_post_status === 'Lapsed' || AssignmentDetailsAry.assign_post_status === 'Check Out') && AssignmentEndPageDetails.checkout_type !== "" && AssignmentEndPageDetails.assign_endtime !== "" && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Assignment End Time</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentEndPageDetails.assign_endtime).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} />
                    </Box>} */}

{(AssignmentDetailsAry.assign_post_status === 'Lapsed' ||
    AssignmentDetailsAry.assign_post_status === 'Check Out') &&
    AssignmentEndPageDetails.assign_endtime !== "" && (
        <Box>
            <Grid container>
                <Grid xs={6} sm={4} md={3}>
                    <Typography variant='body2' fontWeight='bold'>
                        Assignment End Time
                    </Typography>
                </Grid>

                <Grid xs={6} sm={8} md={9}>
                    <Typography variant='body2' color={appThemeColor}>
                        {dayjs(AssignmentEndPageDetails.assign_endtime).format(
                            'hh:mm A [on] MM/DD/YYYY'
                        )}
                    </Typography>
                </Grid>
            </Grid>

            <Divider sx={{ borderRadius: '10px' }} />
        </Box>
    )}
                    {AssignmentDetailsAry.assign_post_status === "Check In" &&
AssignmentEndPageDetails.assign_endtime !== "" && (
    <Box>
        <Grid container alignItems="center">
            <Grid xs={12} sm={4} md={3}>
                <Typography variant="body2" fontWeight="bold">
                    Assignment End Time
                </Typography>
            </Grid>

            <Grid xs={12} sm={8} md={9}>
                {!editEndTime ? (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                       <Box>
    <Typography
        variant="body2"
        color={appThemeColor}
    >
        {dayjs(endTime).format("hh:mm A [on] MM/DD/YYYY")}
    </Typography>

    {endTimeError && (
        <Typography
            variant="caption"
            color="error"
        >
            {endTimeError}
        </Typography>
    )}
</Box>

                        <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => setEditEndTime(true)}
                        >
                            <EditIcon
                                fontSize="small"
                                sx={{ color: appThemeColor }}
                            />
                        </IconButton>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                        }}
                    >
                       <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DateTimePicker
        value={endTime}
        views={["year", "month", "day", "hours", "minutes"]}
        ampm
        minDateTime={dayjs(startTime)}

maxDateTime={
    dayjs(AssignmentDetailsAry.assign_requestdatetime)
        .add(parseInt(AssignmentDetailsAry.assign_duration), "minute")
        .add(24, "hours")
}
        onChange={(newValue) => {

            if (!newValue) return;
        
            const updatedTime = dayjs(newValue);
        
            const assignmentStart = dayjs(startTime);
        
            // Scheduled End Time = Requested DateTime + Duration
            const scheduledEndTime = dayjs(
                AssignmentDetailsAry.assign_requestdatetime
            ).add(
                parseInt(AssignmentDetailsAry.assign_duration),
                "minute"
            );
        
            // Maximum allowed = Scheduled End Time + 24 hours
            const maxAllowedEnd = scheduledEndTime.add(24, "hours");
        
            if (updatedTime.isBefore(assignmentStart)) {
        
                setEndTimeError(
                    `Selected End Date & Time (${updatedTime.format(
                        "MM/DD/YYYY hh:mm A"
                    )}) cannot be earlier than the Assignment Start Time (${assignmentStart.format(
                        "MM/DD/YYYY hh:mm A"
                    )}).`
                );
        
                return;
            }
        
            if (updatedTime.isAfter(maxAllowedEnd)) {
        
                setEndTimeError(
                    `End Date & Time cannot be more than 24 hours after the Scheduled End Date & Time`
                );
        
                return;
            }
        
            setEndTime(updatedTime);
            setEndTimeError("");
        
        }}
        slotProps={{
            textField: {
                size: "small",
                error: endTimeError !== "",
                helperText: endTimeError
            }
        }}
    />
</LocalizationProvider>

<IconButton
    color="success"
    onClick={() => {

        const assignmentStart = dayjs(startTime);
    
        const scheduledEndTime = dayjs(
            AssignmentDetailsAry.assign_requestdatetime
        ).add(
            parseInt(AssignmentDetailsAry.assign_duration),
            "minute"
        );
    
        const maxAllowedEnd = scheduledEndTime.add(24, "hours");
    
        if (endTime.isBefore(assignmentStart)) {
    
            setEndTimeError(
                `Selected End Date & Time (${endTime.format(
                    "MM/DD/YYYY hh:mm A"
                )}) cannot be earlier than the Assignment Start Time (${assignmentStart.format(
                    "MM/DD/YYYY hh:mm A"
                )}).`
            );
    
            return;
        }
    
        if (endTime.isAfter(maxAllowedEnd)) {
    
            setEndTimeError(
                `End Date & Time cannot be more than 24 hours after the Scheduled End Date & Time.`
            );
    
            return;
        }
    
        AssignmentEndPageDetailsSet((previous) => ({
            ...previous,
            assign_endtime: endTime.format("YYYY-MM-DD HH:mm:ss"),
        }));
    
        setEditEndTime(false);
    
    }}
>
    <CheckIcon />
</IconButton>
<IconButton
    color="error"
    onClick={() => {

        setEndTime(
            dayjs(
                AssignmentEndPageDetails.assign_endtime
            )
        );

        setEndTimeError("");

        setEditEndTime(false);

    }}
>
    <CloseIcon />
</IconButton>
                    </Box>
                )}
            </Grid>
        </Grid>

        <Divider sx={{ borderRadius: "10px" }} />
    </Box>
)}
                    {/* {AssignmentDetailsAry.assign_interpreted_duration !== '' && <Box><Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Interpreted Duration</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_interpreted_duration}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /> </Box>} */}

{(AssignmentDetailsAry.assign_interpreted_duration !== "" &&
    (startTime && endTime)) && (
    <Box>
        <Grid container>
            <Grid xs={6} sm={4} md={3}>
                <Typography variant="body2" fontWeight="bold">
                    Interpreted Duration
                </Typography>
            </Grid>

            <Grid xs={6} sm={8} md={9}>
                <Typography variant="body2" color={appThemeColor}>
                    {getInterpretedDuration()}
                </Typography>
            </Grid>
        </Grid>

        <Divider sx={{ borderRadius: "10px" }} />
    </Box>
)}
                    {AssignmentEndPageDetails.checkout_type !== "" && <Box>
                        {/* <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Closure Type</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{(AssignmentEndPageDetails.checkout_type === 'Other') ? 'Time Lapsed' : AssignmentEndPageDetails.checkout_type}</ Typography></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} /> */}
                    </Box>}
                    {/* Sched-1436-starts disabling it */}
                    {/* {(AssignmentDetailsAry.service_type === "InPerson Interpretation" && AssignmentEndPageDetails.paperwork_path !== "") && <Box>
                        <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Paper Works</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Link variant='body2' target="_blank" href={AssignmentEndPageDetails.paperwork_path} color={appThemeColor} >Download Completed Voucher<FileDownloadIcon fontSize='small' sx={{ mb: -0.6 }} /></Link > </Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} />
                    </Box>} */}
                     {/* Sched-1436 ends disabling it */}
                    {URLThirdSegmentName === "Assignment_DetailPage" &&
                        <Box>
                            <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Billing Status</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_bill_status}</ Typography></Grid> </Grid>
                            <Divider sx={{ borderRadius: '10px' }} />
                            <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Requested Duration</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_duration}</ Typography></Grid> </Grid>
                            <Divider sx={{ borderRadius: '10px' }} />
                            {/* <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Completion Type</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_completion_type}</ Typography></Grid> </Grid>
                            <Divider sx={{ borderRadius: '10px' }} /> */}

                        </Box>
                    }

                </Box>
                {/* Sched-1436-startsdisabling it */}
                {/* {AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'end', mt: 1 }}>
                        <LoadingButton size='small' sx={{ color: appThemeColor, textTransform: 'none', textDecoration: 'underline' }} onClick={() => AssignmentDownloadVoucherHtml(assign_id)} startIcon={<DownloadIcon fontSize='small' sx={{ mr: -0.5 }} />} loadingPosition='start' loading={DownloadVoucherLoadingButton}>
                            Download Blank Voucher
                        </LoadingButton>
                    </Box>
                </Box>} */}
                 {/* Sched-1436-ends disabling it */}
            </Box>

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                <TranslateOutlinedIcon sx={{ color: appThemeColor, fontSize: '16px', mt: '2px', mr: 0.2 }} /> <Typography variant="subtitle2" color={appThemeColor} sx={{ letterSpacing: '-0.2px' }} > {AssignmentDetailsAry.language_name} | {AssignmentDetailsAry.service_type_short} | {AssignmentDetailsAry.assign_service_mode}</Typography>
            </Box>





            <Box sx={{ display: 'flex', justifyContent: 'center', ml: { xs: 0, sm: 1, md: 1 }, mb: -2 }}>
                <Typography variant='caption' sx={{ letterSpacing: '-0.2px' }}>Time Zone : {AssignmentDetailsAry.assign_timezone_daylight}</ Typography>
            </Box>
        </Box >
    )
}

